import type { TechnologyStatus as Status } from '../../data/technologies'

export function TechnologyStatus({ status }: { status: Status }) {
  return <span className={`tech-status tech-status--${status}`}><i /> Status / {status}</span>
}
